import { SectionType } from '@/typings/enums/enums';
import { ModelTypes } from '@/typings/types/types';
import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';

interface TabStrings {
  plural?: string;
  single?: string;
  addNew?: string;
}

export interface TabsCategories {
  id: SectionType;
  label?: string;
  active?: boolean;
  hide?: boolean;
  isActive?: boolean;
  strings?: TabStrings;
}

export interface EditingState {
  showGameSettingsModal: boolean;
  showLayoutSettingsModal: boolean;
  isNavigatorActive: boolean;
  activeTabCategory?: SectionType;
  activeFormUrl: string;
  activeModel: ModelTypes | undefined;
  activeNavigatorId: string | number | null;
  isContextMenuVisible: boolean;
  selectedContextItem?: ModelTypes;
  contextXPosition: number;
  contextYPosition: number;
  sectionWithGame: SectionBaseModel | null;
  navigatorCategories: TabsCategories[];
}

export const state = (): EditingState => {
  return {
    showGameSettingsModal: false,
    showLayoutSettingsModal: false,
    isNavigatorActive: false,
    activeTabCategory: SectionType.SECTION,
    activeFormUrl: '',
    activeModel: undefined,
    activeNavigatorId: null,
    isContextMenuVisible: false,
    selectedContextItem: undefined,
    contextXPosition: 0,
    contextYPosition: 0,
    sectionWithGame: null,
    navigatorCategories: [
      {
        id: SectionType.SECTION,
        label: 'Sections',
        active: true,
        strings: {
          plural: 'sections',
          single: 'section',
          addNew: 'Add new section'
        }
      },
      {
        id: SectionType.FLOWPAGE,
        isActive: false,
        hide: false,
        label: 'Flow pages',
        strings: {
          plural: 'flow pages',
          single: 'flow page',
          addNew: 'Add new flow page'
        }
      },
      {
        id: SectionType.POPOVER,
        isActive: false,
        hide: false,
        label: 'Popovers',
        strings: {
          plural: 'popovers',
          single: 'popover',
          addNew: 'Add new popover'
        }
      }
    ]
  };
};
